/**
 * 一些业务相关的 helper 函数, 所有函数都以 `$` 开头
 */

import { v4 as uuid } from 'uuid'
import { STORAGE_APP_ID, STORAGE_OPEN_ID, STORAGE_TOKEN, STORAGE_UUID } from '@/constants'

export function $log(ns: string, ...args: unknown[]) {
  // eslint-disable-next-line no-console
  console.log(`[${ns}]:`, ...args)
}

export const $uuid = uuid
export function $requestId() {
  return `col-${uuid()}`
}

export function $uuidWithCached() {
  let id = window.localStorage.getItem(STORAGE_UUID)
  if (id)
    return id

  id = uuid()
  window.localStorage.setItem(STORAGE_UUID, id)
  return id
}

export function $getAppId() {
  return window.localStorage.getItem(STORAGE_APP_ID)
}
export function $setAppId(appId: string) {
  window.localStorage.setItem(STORAGE_APP_ID, appId)
}
export function $removeAppId() {
  window.localStorage.removeItem(STORAGE_APP_ID)
}
export function $getToken() {
  return window.localStorage.getItem(STORAGE_TOKEN)
}
export function $setToken(token: string) {
  window.localStorage.setItem(STORAGE_TOKEN, token)
}
export function $removeToken() {
  window.localStorage.removeItem(STORAGE_TOKEN)
}
export function $getOpenId() {
  return window.localStorage.getItem(STORAGE_OPEN_ID)
}
export function $setOpenId(openId: string) {
  window.localStorage.setItem(STORAGE_OPEN_ID, openId)
}
export function $removeOpenId() {
  window.localStorage.removeItem(STORAGE_OPEN_ID)
}
export function $isLogin() {
  return !!$getToken() && !!$getOpenId()
}
export function $login({ token, openId }: { token: string; openId: string }) {
  $setToken(token)
  $setOpenId(openId)
}
export function $logout() {
  $removeToken()
  $removeOpenId()
}

export function $loadTextFromCDN(url: string) {
  return new Promise<string>((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = () => {
      if (xhr.status === 200)
        resolve(xhr.responseText)

      else reject(xhr.statusText)
    }
    xhr.onerror = () => reject(xhr.statusText)
    xhr.send()
  })
}

export function $formatErrorMessage(error: any) {
  if (typeof error === 'string')
    return error

  if (error.msg)
    return error.msg

  if (error instanceof Error)
    return error.message

  return JSON.stringify(error)
}

// 80 => `01:20`
export function $formatSeconds(seconds: number) {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
}
